namespace GeniuzPOS.InitialData {
    export class PsPosPrinterColumns {
        static columnsKey = 'InitialData.PsPosPrinter';
    }
}
